import moment from 'moment-timezone/moment-timezone';

const fromDateToMomentTzFormat = date => moment(date).format();

export default fromDateToMomentTzFormat;
